module.exports = __webpack_public_path__ + "static/media/18ECA30.667a1d95.jpg";